import React, { useEffect, useState } from "react";
import OrderService from "../../services/OrderService";
import TrackOrderV4 from "./v4/TrackOrder";
import TrackOrderV3 from "./v3/TrackOrder";
import UserService from "../../services/UserService";
import Analytics, { TRACK_PAGE_CATEGORIES } from "../../lib/anayltics";
import Page from "../../components/Page";
import { IonHeader, IonIcon, IonSpinner } from "@ionic/react";
import styled from "styled-components";
import ErrorComponent from "../../components/Error";
import { KitchenVersions } from "../../constants/XookConstants";
import { connect } from "react-redux";
import withNav from "../../utils/hoc/withNav";
import { bindActionCreators } from "@reduxjs/toolkit";
import { setUserData } from "../../actions/UserActions";
import { NavLink } from "react-router-dom";
import { chevronBackOutline, home, homeOutline } from "ionicons/icons";
import { GUEST_FLOW_ERROR_CODE } from "../../config/error";
import AsyncContentWrapper from "../../components/AsyncContentWrapper";
import { PrimaryText } from "../../components/Texts";
import { getOrderCode } from "../../utils/misc";

const Center = styled.div`
	display: flex;
	flex-direction: column;
	text-align: center;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 100%;
`;

const PageHeader = styled(IonHeader)`
	position: sticky;
	top: 0;
	margin: 0 0 0 0;
	background: ${({ theme }) => theme.colors.main.background};
	font-family: inherit;
	font-style: normal;
	font-size: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1.5rem 1rem;
	border: none;
	box-shadow: none;
	&:after {
		background-image: none;
	}
`;

const PaddedElement = styled.div`
	margin-top: 4rem;
`;

const BackButton = styled(NavLink)``;

const BackButtonImg = styled(IonIcon)`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 24px;
	height: 24px;
	color: #fff;
	/* Icon alignment */
	margin-left: -5px;
	margin-top: -4px;
`;

const PageTitle = styled.div`
	/* Keeping it centered becuase of icon alignment */
	padding-left: 10px;
	font-style: normal;
	font-weight: 900;
	font-size: 20px;
	letter-spacing: 0px;
	display: flex;
	justify-content: center;
`;

const HelpButton = styled(IonIcon)`
	width: 20px;
	height: 20px;
	margin-left: auto;
`;

const Box = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 0 1rem;
`;

function mapKitchenVersionToComponent({ orderData, ...rest }: any) {
	switch (orderData?.kitchenVersion) {
		case KitchenVersions.V4:
			return <TrackOrderV4 initialOrderData={orderData} {...rest} />;

		case KitchenVersions.V3:
		default:
			return <TrackOrderV3 initialOrderData={orderData} {...rest} />;
	}
}

function createHandler(navigate: any) {
	return function (metadata: any) {
		if (metadata && navigate) {
			const { code } = metadata;
			switch (code) {
				case GUEST_FLOW_ERROR_CODE.LINK_EXPIRED:
					navigate.push(`/auth/expired`, "forward", "replace");
					break;
				default:
					break;
			}
		}
	};
}

const GuestTrackOrder = (props: any) => {
	const { uuid, navigate } = props;
	const { kioskId, id: orderId } = props.match.params;

	const [initialOrderData, setInitialOrderData] = useState({});
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");
	const errorMetaDataHandler = createHandler(navigate);

	async function getOrderData(orderId: string, uuid: string) {
		if (!orderId) {
			setError("");
			return;
		}
		const response = await OrderService.trackOrder(orderId, uuid);
		const { data, error, errorCode, metadata } = response;
		if (data) {
			setInitialOrderData(data);
		}
		if (error) {
			if (metadata) {
				errorMetaDataHandler(metadata);
			} else {
				setError(errorCode);
				console.log(error);
			}
		}
		setLoading(false);
	}

	async function onPageLoad() {
		Analytics.trackPage(TRACK_PAGE_CATEGORIES.PAGE_LOAD, "Track Order Guest");
		getOrderData(orderId, uuid);
	}

	useEffect(() => {
		onPageLoad();
	}, []);

	function renderOrderDetails(loading: boolean, error: any) {

		if(loading || error) return;

		const orderCode = getOrderCode(orderId);
		return (
			<Box>
				<PrimaryText>Order #{orderCode}</PrimaryText>
			</Box>
		);
	}

	function renderChildren(loading: boolean, error: any, initialOrderData: any, uuid?: any) {
		return (
			<AsyncContentWrapper isLoading={loading} error={error} errorComponent={() => <ErrorComponent code={error} />}>
				{mapKitchenVersionToComponent({ orderData: initialOrderData, orderId, kioskId, uuid, errorMetaDataHandler })}
			</AsyncContentWrapper>
		);
	}

	return (
		<Page padding="0">
			<PageHeader>
				<BackButton to={`/login`}>
					<BackButtonImg src={home} />
				</BackButton>
				<PageTitle>Track Order</PageTitle>
				<HelpButton />
			</PageHeader>
			{renderOrderDetails(loading, error)}
			{renderChildren(loading, error, initialOrderData, uuid)}
		</Page>
	);
};

//Redux mapping
const mapStateToProps = (state: any) => {
	const {
		User: { dietaryPreferences },
	} = state;
	return { dietaryPreferences };
};

const mapDispatchToProps = (dispatch: any) => ({
	...bindActionCreators(
		{
			setUserData,
		},
		dispatch
	),
});

export default connect(mapStateToProps, mapDispatchToProps)(withNav(GuestTrackOrder));
